import React, { useState, useEffect } from "react";
import Navber from "../../Components/Navber.jsx";
import "./Jayraj_transport.css";
import { FaBus, FaTrain, FaPlane, FaTaxi } from "react-icons/fa";
import { useParams } from "react-router-dom";
import BusSearchDown from "./BusSearchDown.jsx";
import FlightSearchDown from "./FlightSearchDown.jsx";

import FlightSearch from "./FlightSearch";
import BusSearch from "./BusSearch";
import TrainSearch from "./TrainSearch";
import CabSearch from "./CabSearch";

function Transport_page() {
  const { button } = useParams();
  const validTabs = ["bus", "train", "plane", "cab"];

  const [activeTab, setActiveTab] = useState("plane"); // default

  // 🔁 Sync URL param with tab state
  useEffect(() => {
    if (validTabs.includes(button)) {
      setActiveTab(button);
    }
  }, [button]);
  const bgImages = {
    plane: "https://images.pexels.com/photos/674783/pexels-photo-674783.jpeg",
    bus: "https://media.istockphoto.com/id/124870370/photo/touring-america-ii.jpg?s=612x612&w=0&k=20&c=R4jc_JhLBKnxAc3xqYfT5HNKqGabXOIHIJ6u-7iKrdk=",
    train: "https://images.pexels.com/photos/730778/pexels-photo-730778.jpeg",
    cab: "https://images.pexels.com/photos/210182/pexels-photo-210182.jpeg"
  };


  return (
    <>
      <Navber />

      <section
        className="travel-hero"
        style={{
          backgroundImage: `url(${bgImages[activeTab]})`
        }}
      >

        <div className="travel-container">

          {/* Tabs */}
          <div className="transport-tabs">
            {[
              { key: "bus", icon: <FaBus />, label: "Bus" },
              { key: "train", icon: <FaTrain />, label: "Train" },
              { key: "plane", icon: <FaPlane />, label: "Flights" },
              { key: "cab", icon: <FaTaxi />, label: "Cab" }
            ].map(tab => (
              <button
                key={tab.key}
                className={`transport-tab ${activeTab === tab.key ? "active" : "nonactive"}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.icon}
                <span>{tab.label}</span>
              </button>
            ))}
          </div>

          {/* Booking Card */}
          <div className="booking-card fade-in">
            {activeTab === "plane" && <FlightSearch />}
            {activeTab === "bus" && <BusSearch />}
            {activeTab === "train" && <TrainSearch />}
            {activeTab === "cab" && <CabSearch />}
          </div>

        </div>
        {/* <BusSearchDown/> */}
      </section>
      {activeTab === "plane" && <FlightSearchDown />}
      {activeTab === "bus" && <BusSearchDown />}
     
    </>
  );
}

export default Transport_page;
